(function () {
    'use strict';

    angular.module('app.routes')

        .config(function ($stateProvider) {

            $stateProvider

                .state('app.module.surfing_report', {
                    url: '/surfing-report',
                    abstract: true,
                    resolve: {
                        user: function () {
                            return true;
                        }
                    },
                    onEnter: function (user, $state, SETTINGS, App) {
                        if (!user) $state.go(SETTINGS.LOGIN_STATE);
                        App.module = 'surfing_report';
                    },
                    views: {
                        '@app': {
                            templateUrl: 'views/surfing_report/index.html'
                        }
                    }
                })
                .state('app.module.surfing_report.default', {
                    url: '',
                    onEnter: function (App) {
                        App.page = 'surfing_report';
                    },
                    templateUrl: 'views/surfing_report/default.html',
                    controller: 'SurfingReportCtrl',
                    controllerAs: 'vm'
                })
            ;
        })

        .run(function (App) {

            App.modules.push({
                route: 'app.module.surfing_report.default',
                module: 'surfing_report',
                name: 'Surfing Report',
                order: 2,
                pages: [
                    {name: '', page: 'default', route: 'app.module.surfing_report.default'}
                ]
            });
        })

    ;

})();